import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import momentTimezone from "moment-timezone"
import {
  loadSigleEmail,
  downloadSingleEmailsReport,
  clearData,
} from "../../../Containers/EmailValidation/actions";
import Session from "../../../utility/session";
import { CLEAR_SINIGLE_EMAILS_DATA } from "../../../common/constants";
const mapStateToProps = (state) => {
  return {
    loading: state.emailverificationinfo.singleEmailsLoading,
    singleEmailverificationresults: state.emailverificationinfo.singleEmailverificationresults || [],
    singleEmailData:state.emailverificationinfo.singleEmailData || {}
  }
};
class SingleVerificationList extends React.Component {
  constructor(props) {
    super(props);
    this._handleClick = this._handleClick.bind(this);
    this.checkUpdates = this.checkUpdates.bind(this);
    this.clearTimer = this.clearTimer.bind(this);
    this.setTimer = this.setTimer.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }
  _handleClick(e) {
    this.props.dispatch(downloadSingleEmailsReport({timeZone: momentTimezone.tz.guess()}));
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    const { dispatch } = this.props;
    // const {selectedIndex} = this.props.singleEmailverificationresults || [];
    this.checkUpdates({
      skip: 0,
      limit: 10,
      initial: true,
      timer: false,
      page:0,
      uploadedResults: [],
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEmailData.inprocess) {
      // console.log("Files in process");
      this.setTimer();
    } else {
      this.clearTimer();
    }
  }
  componentWillUnmount() {
    this.clearTimer();
    window.removeEventListener("scroll", this.handleScroll);
    this.props.dispatch(clearData(CLEAR_SINIGLE_EMAILS_DATA))
  }
  setTimer() {
    const {
      skip,
      limit,
      page,
    } = this.props.singleEmailData;
    if (this.timer === undefined) {
      this.timer = setInterval(() => {
        this.checkUpdates({
          skip,
          limit:(this.props.singleEmailverificationresults || []).length,
          initial: false,
          append: false,
          timer: true,
          page:0,
          // uploadedResults: uploadedResults,
        });
      }, 15000);
    }
  }
  clearTimer() {
    if (this.timer !== undefined) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  checkUpdates(i) {
    console.log("Update files");
    this.props.dispatch(
      loadSigleEmail({
        username: Session.getItem("current_username"),
        skip: i.skip,
        limit: i.limit,
        initial: i.initial,
        timer: i.timer,
        selectedIndex: i.selectedIndex,
        page:i.page
        // uploadedResults: i.uploadedResults,
      })
    );
  }
  handleScroll() {
    let winHeight = window.innerHeight;
    let scrollTop = document.documentElement.scrollTop;
    let scrollHeight = document.body.scrollHeight;
    const statsComponent = document.querySelector(".emails-stats-right");
    const emailVerification = document.querySelector(".emailVerification");
    if (statsComponent) {
      if (this.sticky == undefined)
        this.sticky = statsComponent.getBoundingClientRect().top;
      if (window.pageYOffset >= this.sticky) {
        statsComponent.classList.add("sticky");
        statsComponent.style.width =
          emailVerification.getBoundingClientRect().width / 2 + "px";
      } else if (statsComponent) {
        statsComponent.classList.remove("sticky");
        statsComponent.style.width = "";
      }
    }
    const selectedFileComponent = document.querySelector(".activeTimeline");
    if (selectedFileComponent) {
      if (this.stickyFile == undefined)
        this.stickyFile = selectedFileComponent.getBoundingClientRect().top;

      if (window.pageYOffset + 50 >= this.stickyFile) {
        selectedFileComponent.classList.add("sticky-left");
        selectedFileComponent.style.width =
          parseInt(emailVerification.getBoundingClientRect().width / 2) -
          70 +
          "px";
      } else {
        selectedFileComponent.classList.remove("sticky-left");
        selectedFileComponent.style.width = "";
      }
    }
    if (scrollHeight == winHeight + scrollTop) {
      console.log("Page Bottom load more files");
      const {
        hasMore,
        skip,
        limit,
        page,
        loading,
      } = this.props.singleEmailData;
      if (hasMore) {
        console.log(`Has more triggered`)
        this.props.dispatch(
          loadSigleEmail({ 
            username: Session.getItem("current_username"),
            skip: skip,
            page,
            limit,
          })
        );
      }
    }
  }
  render() {
    const emailsList = this.props.singleEmailverificationresults
      ? this.props.singleEmailverificationresults
      : [];
    //console.log(this.props.emails);
    // console.log("****(&*&*&**&**************&",emailsList);
    return (
      <div
        role="tabpanel"
        className={"tab-pane fade singleEmailValidation active in"}
        id="tab_content2"
        aria-labelledby="profile-tab"
      >
        {/*<!-- start tab 01 -->*/}
        <div className="emailVerificationTiles">
          <div className="delMenu">
            <a
              className="download-report"
              name={"valid"}
              onClick={this._handleClick}
            >
              <i
                style={{
                  float: "right",
                  cursor: "pointer",
                  paddingRight: "5%",
                }}
                className="fa fa-cloud-download dropdown-toggle"
                data-toggle="dropdown"
              />
            </a>
          </div>
        </div>
        <ul className="list-unstyled timeline" style={{ direction: "ltr" }}>
          {(this.props.loading && !emailsList.length) ? "" : emailsList.length ? emailsList.map((item, key) => (
            <li key={key}>
              <div className="block">
                <div className="block_content">
                  <h2 className="title" style={{ float: "left" }}>
                    {item.email}
                  </h2>
                  <ul className="emailStatus">
                    <li className="em-status">
                      <span>Status:</span> {item.status}
                    </li>
                    <li>|</li>
                    <li className={"em-result text-" + item.className} style={{textTransform:"capitalize"}}>
                      <span>Result:</span> {item.result || "N/A"}
                    </li>
                    <li>|</li>
                    {
                    item.result == "unknown" && item.score > 0 &&
                    (<span><li className="em-safeToSend">
                      <span>Score:</span> 
                      <li>{
                      item.score >= 0 ? item.score : "N/A"}</li>
                    </li>
                    <li>|</li></span>) 
                    || ""
                    }
                    <li className="em-safeToSend">
                      <span>Safe to send:</span> 
                      <span>{item.result ? item.safe_to_send == "true" ? "Yes" : "No" : "N/A"}</span>
                    </li>
                    <li>|</li>
                    <li className="em-date">
                      <span />
                      {item.result ? moment(item.verified_date).format("MMM DD YYYY HH:mm") : moment(item.time).format("MMM DD YYYY HH:mm")}
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          )): <p style={{opacity:0.7, textAlign:"center"}}>No emails verified till now.</p>}
        </ul>
        {/*<!-- end tab 01 -->*/}
      </div>
    );
  }
}

export default connect(mapStateToProps)(SingleVerificationList);



// WEBPACK FOOTER //
// ./src/components/EmailVerification/VerificationJobsList/SingleVerificationList.js